import { render, staticRenderFns } from "./service-agreement.vue?vue&type=template&id=3f954653&"
import script from "./service-agreement.vue?vue&type=script&lang=js&"
export * from "./service-agreement.vue?vue&type=script&lang=js&"
import style0 from "./service-agreement.vue?vue&type=style&index=0&id=3f954653&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports